module.exports = __webpack_public_path__ + "static/images/containers/PostbattleScreen/components/BattleList/images/divider-column.3913c99f.png";


//////////////////
// WEBPACK FOOTER
// ./containers/PostbattleScreen/components/BattleList/images/divider-column.png
// module id = 3209
// module chunks = 11